import { createContext, useContext } from 'react';

export const ToastContext = createContext({ addToast: () => {}, dismiss: () => {} });

export function useToast() {
  return useContext(ToastContext);
}
